var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./AddNutritionInfo.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7da68ed8!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AddNutritionInfo.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Add/AddNutritionInfo.vue
// module id = 583
// module chunks = 0